<script>
export default {
  computed: {
    getSelectedProducts() {
      let total = 0;
      this.$store.getters.getSelectedProducts.forEach((element) => {
        total += element.totalAmount;
        // total += element.price * element.quantity;
      });
      return (Math.round(total * 100) / 100).toFixed(2);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/mixins/Footer_Mixin.vue